<template>
  <!-- grid display -->
  <ul
    role="list"
    class="grid responsive-gap grid-cols-3 md:grid-cols-4 xl:grid-cols-6"
  >
    <template v-if="!titles">
      <li v-for="_ in Array(30)" class="space-y-2">
        <Skeleton class="w-full aspect-[5/7]" />
        <Skeleton class="h-10" />
      </li>
    </template>
    <template v-else>
      <li v-for="title in titles" :key="title.id">
        <TheNuxtLink :to="(hrefFn ?? linkTo)(title)">
          <TitleCover class="hover-scale shadow" :title="title" res="512" />
          <p class="line-clamp-2 mt-2 text-sm sm:text-base">
            {{ extractFromLocale(locale, title.attributes.title) }}
          </p>
        </TheNuxtLink>
        <!--<p class="pointer-events-none block text-sm font-medium text-gray-500">{{ title.genre }}</p>-->
      </li>
    </template>
  </ul>
</template>

<script setup lang="ts">
import type { TitleEntity } from "~/src/api";

interface Props {
  titles?: TitleEntity[];
  hrefFn?: (title: TitleEntity) => string;
}
const { locale, t: translate } = useI18n();
defineProps<Props>();
</script>
